<template>
  <div class="elrowspan">
    <el-row>
      <el-col :span="12">
        <div>
          <el-input placeholder="" v-model="SerialOptions.baudRate">
            <template slot="prepend">波特率</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div>
          <el-input placeholder="" v-model="SerialOptions.dataBits">
            <template slot="prepend">数据位</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div>
          <el-input placeholder="" v-model="SerialOptions.stopBits">
            <template slot="prepend">停止位</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div>
          <el-input placeholder="" v-model="SerialOptions.parity">
            <template slot="prepend">校验位</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div>
          <el-input placeholder="" v-model="SerialOptions.bufferSize">
            <template slot="prepend">缓冲区</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div>
          <el-input placeholder="" v-model="SerialOptions.flowControl">
            <template slot="prepend">流控制</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-button type="primary" @click="selectport()">串口选择</el-button>
        <span v-if="serialStatuChange ===true" style="padding-left: 10px">设备已连接</span>
        <span v-if="serialStatuChange ===false" style="padding-left: 10px">设备未连接</span>
      </el-col>
    </el-row>
    <template>
      <el-upload
        class="upload-demo"
        action=""
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传</div>
      </el-upload>
      <button @click="add">调用DLL</button>
    </template>
  </div>
</template>
<script>
// import axios from 'axios'

export default {
  data() {
    return {
      activeName: 'first',
      tabPosition: 'left',
      // 串口设置
      dataHexinput: [],
      nfcstate: [],
      newmsg: '',
      dataHexinputall: '',
      nfcstateall: '',
      asciidecoder: new TextDecoder(),
      serialToggle: '打开串口',
      SerialOptions: {
        // 波特率
        baudRate: 38400,
        // 数据位
        dataBits: 8,
        // 停止位
        stopBits: 1,
        // 校验位
        parity: 'none',
        // 缓冲区
        bufferSize: 1024,
        // 流控制
        flowControl: 'none'
      },
      reader: null,
      // 串口缓存数据
      serialData: [],
      // 串口目前是打开状态
      serialOpen: false,
      // 设置表单打开
      nfcsetVisible: false,
      // 设备是否链接
      serialStatuChange: false,
      serialClose: true,
      serialPort: null,
      // 串口发送接收的数据
      contenttext: '',
      toolOptions: {
        // 自动滚动
        autoScroll: true,
        // 显示时间 界面未开放
        showTime: true,
        // 日志类型
        logType: 'hex&ascii',
        // 分包合并时间
        timeOut: 50,
        // 末尾加回车换行
        addCRLF: false,
        // HEX发送
        hexSend: false,
        // 循环发送
        loopSend: false,
        // 循环发送时间
        loopSendTime: 1000,
        // 输入的发送内容
        sendContent: '',
        // 快捷发送选中索引
        quickSendIndex: 0
      },
      // 升级文件列表
      fileList: []
    }
  },
  components: {},
  created() {},
  mounted() {},
  destroyed() {},
  computed: {},
  methods: {
    // 串口连接
    async selectport() {
      try {
        const port = await navigator.serial.requestPort()
        // this.serialPort.close()
        // await this.serialPort.forget()
        this.serialPort = port
        this.serialStatuChange = true
      } catch (e) {
        console.error(this.$t('screen.name38') + e.toString())
      }
    },
    // 判断串口状态
    serialToggleSerial() {
      if (!this.serialPort) {
        return this.$message.error(this.$t('public.name70'))
      }
      if (this.serialPort.writable && this.serialPort.readable) {
        this.closeSerial()
        this.serialClose = true
        return
      }
      this.openSerial()
    },
    // 打开串口
    async openSerial() {
      this.serialPort.open(this.SerialOptions)
        .then(() => {
          this.serialOpen = true
          this.serialClose = false
          this.serialStatuChange = true
          localStorage.setItem('serialOptions', JSON.stringify(this.SerialOptions))
          this.readData()
        })
        .catch((e) => {
          return this.$message.error(this.$t('public.name71') + e.toString())
        })
    },
    // 读串口数据
    async readData() {
      while (this.serialOpen && this.serialPort.readable) {
        this.reader = this.serialPort.readable.getReader()
        try {
          while (true) {
            const {
              value,
              done
            } = await this.reader.read()
            if (done) {
              break
            }
            this.dataReceived(value)
          }
        } catch (error) {
        } finally {
          this.reader.releaseLock()
        }
      }
      await this.serialPort.close()
    },
    dataReceived(data) {
      this.serialData.push(...data)
      if (this.toolOptions.timeOut === 0) {
        this.dataHex(this.serialData, true)
        this.serialData = []
        return
      }
      // 清除之前的时钟
      clearTimeout(this.serialTimer)
      this.serialTimer = setTimeout(() => {
        // 超时发出
        this.dataHex(this.serialData, true)
        this.serialData = []
      }, this.toolOptions.timeOut)
    },
    // 关闭串口
    closeSerial() {
      if (this.serialOpen) {
        this.serialOpen = false
        this.reader.cancel()
        // this.serialStatuChange = false
      }
    },
    // 串口数据收发
    async send(content) {
      this.contenttext = content
      if (!content) {
        return this.$message.error(this.$t('public.name72'))
      }
      await this.sendText(content)
    },
    // 发送ASCII到串口
    sendText(text) {
      const encoder = new TextEncoder()
      this.writeData(encoder.encode(text))
    },
    async writeData(data) {
      if (!this.serialPort || !this.serialPort.writable) {
        return this.$message.error(this.$t('public.name73'))
      }
      let writer = null
      try {
        writer = this.serialPort.writable.getWriter()
        if (this.toolOptions.addCRLF) {
          data = new Uint8Array([...data, 0x0d, 0x0a])
        }
        await writer.write(data)
      } catch (error) {
        return this.$message.error(error.toString())
      } finally {
        writer.releaseLock()
        this.dataHex(data, false)
      }
      // const writer = this.serialPort.writable.getWriter()
      // if (this.toolOptions.addCRLF) {
      //   data = new Uint8Array([...data, 0x0d, 0x0a])
      // }
      // await writer.write(data)
      // writer.releaseLock()
      // this.dataHex(data, false)
    },
    dataHex(data, isReceive = true) {
      const dataHex = []
      this.dataHexinput = []
      this.nfcstate = []

      this.newmsg = ''
      if (this.toolOptions.logType.includes('hex')) {
        for (const d of data) {
          // 转16进制并补0
          dataHex.push(('0' + d.toString(16).toLocaleUpperCase()).slice(-2))
        }
        if (isReceive === true) {
          // console.log(dataHex.length)
          this.dataHexinput = dataHex.slice(0, 4)
          this.dataHexinputall = this.dataHexinput.join('')
          this.nfcstate = dataHex.slice(4, 5)
          this.nfcstateall = parseInt(this.nfcstate.join(''))
          this.$store.commit('applicationstore/Setsendstate', this.nfcstateall)
        }
      }
      if (this.toolOptions.logType.includes('ascii')) {
        this.newmsg = this.asciidecoder.decode(Uint8Array.from(data))
      }
      if (isReceive === true) {
        if (this.contenttext === 'aNFCRead') {
          if (this.dataHexinputall) {
            if (this.nfcstateall === 0) {
              this.$store.commit('applicationstore/Setsendcode', '')
              // sendbus.$emit('getallinfo')
              // return this.$message.warning(this.$t('screen.name322'))
            } else {
              this.$store.commit('applicationstore/Setsendcode', this.dataHexinputall)
              // sendbus.$emit('getallinfo')
              // return this.$message.success('该卡片已激活')
            }
          } else {
            // return this.$message.error(this.$t('screen.name43'))
          }
        }
      }
    },
    // 上传升级文件
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(this.$t('public.name74'))
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 调用DLL文件
    add() {
      // ipcRenderer.send('calltest', JSON.stringify(this.tabPosition))
    }
  }
}
</script>
<style lang="scss" scoped>
.elrowspan  {
  margin-top: 10px;
}
.el-row{
  margin-top: 10px;
}
</style>
